import { render, staticRenderFns } from "./SendInviteRequestModal.vue?vue&type=template&id=f5ed6bea&scoped=true"
import script from "./SendInviteRequestModal.vue?vue&type=script&lang=js"
export * from "./SendInviteRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ed6bea",
  null
  
)

export default component.exports